<div class="flex flex-col gap-3 q-valoration" [ngClass]="{ 'roadRightMode': roadRightMode, 'roadBelowMode': roadBelowMode }">
  <ng-content select="[questionLabel]"></ng-content>

  <div class="">
    <ng-container *ngIf="valorationType === 'emoji'">
      <ion-radio-group
        (ionChange)="handleChange($event)"
        [(ngModel)]="question.answer"
        class="question-radio flex flex-col"
      >
        <div class="flex flex-col items-center relative" *ngFor="let option of question.opciones">
          <ion-radio
            class="opacity-0"
            [value]="option.value"
            color="primary"
            mode="md"
            labelPlacement="stacked" alignment="center"
          >{{option.text}}
          </ion-radio>

          <div class=" absolute top-0 left-0 right-0 bottom-0  flex flex-col items-center gap-2 lg:gap-3 hover:bg-gray-100">
            <ion-icon *ngIf="valorationSelected != option.value" name="ellipse-outline" class="emoji-icon text-gray-500"></ion-icon>
            <span *ngIf="valorationSelected == option.value"  class="emoji-icon">{{option.emoji}} </span>
            <span class="text-xxs sm:text-xs lg:text-sm  leading-[14px] lg:leading-4 text-center"><span [outerHTML]="option.text"></span></span>
          </div>
        </div>
      </ion-radio-group>
    </ng-container>

    <ng-container *ngIf="valorationType === 'stars'">
      <ion-radio-group
      (ionChange)="handleChange($event)"
      [(ngModel)]="question.answer"
      class="question-radio flex flex-col"
    >
      <div class="flex flex-col items-center relative" *ngFor="let option of question.opciones">
        <ion-radio
          class="opacity-0"
          [value]="option.value"
          color="primary"
          mode="md"
          labelPlacement="stacked" alignment="center"
        >{{option.text}}
        </ion-radio>

        <div class="absolute top-0 left-0 right-0 bottom-0 w-[60px] flex flex-col items-center gap-2 lg:gap-3 hover:bg-gray-100">
          <img *ngIf="valorationSelected >= option.value; else outlineStar"
          src="assets/icon/star-filled.svg"
          class="star-img"
          >
          <span class="text-xxs sm:text-xs lg:text-sm leading-[14px] lg:leading-4 text-center"><span [outerHTML]="option.text"></span></span>
        </div>
      </div>

      <ng-template #outlineStar>
        <img src="assets/icon/star-outline-contrast.svg" class="star-img">
      </ng-template>
    </ion-radio-group>

    </ng-container>
  </div>
</div>
